/* @flow */

import React, { PureComponent } from 'react'
import Basic from './basic'
import type { BasicPropsType, BasicStateType } from './basic'

type SelectValuesEntryType = { value: string, label: string, disabled?: boolean, items?: SelectValuesType }
type SelectValuesType = Array<SelectValuesEntryType>

type SelectPropsType = BasicPropsType & {
  values: SelectValuesType,
  value?: number | string,
  hasEmpty?: boolean,
  emptyLabel: string,
  disabled: boolean,
  inputClassName: string,
  OptionComponent?: PureComponent<SelectOptionPropsType, {}>
}

type SelectStateType = BasicStateType & {}

type SelectOptionPropsType = {
  entry: SelectValuesEntryType,
  index: number,
  values: ?SelectValuesType
}

class SelectOption extends PureComponent<SelectOptionPropsType, {}> {
  props: SelectOptionPropsType

  render() {
    const { entry } = this.props
    if (entry.items) {
      return (
        <optgroup label={entry.label}>
          {entry.items.map((subEntry: SelectValuesEntryType, index) => {
            return (
              <SelectOption
                index={index}
                values={entry.items}
                entry={subEntry}
                key={subEntry.value || `index-${index}`}
              />
            )
          })}
        </optgroup>
      )
    } else {
      return (
        <option disabled={entry.disabled} value={entry.value}>
          {entry.label}
        </option>
      )
    }
  }
}

class Select extends Basic<SelectPropsType, SelectStateType> {
  props: SelectPropsType

  static defaultProps = {
    ...Basic.defaultProps,
    hasEmpty: true,
    emptyLabel: '',
    inputClassName: 'atp-input__select',
    OptionComponent: SelectOption
  }

  getValue = (event: SyntheticInputEvent<HTMLSelectElement>): void => {
    const { values, hasEmpty } = this.getProps()
    const select = event.target
    // $FlowFixMe
    const option = select.options[select.selectedIndex]
    const optionGroup = option.parentNode
    if (optionGroup instanceof HTMLOptGroupElement) {
      const groupPosition = Array.prototype.indexOf.call(select.children, optionGroup)
      const elementPosition = Array.prototype.indexOf.call(optionGroup.children, option)
      const index = groupPosition - (hasEmpty ? 1 : 0)
      if (index < 0) return this.handleChange(null)
      // $FlowFixMe
      this.handleChange(values[index].items[elementPosition].value)
    } else {
      // $FlowFixMe
      const index = select.selectedIndex - (hasEmpty ? 1 : 0)
      if (index < 0) return this.handleChange(null)
      this.handleChange(values[index].value)
    }
  }

  formField(): React$Element<*> {
    const props = this.getProps()
    const OptionComponent = props.OptionComponent
    return (
      <select
        className={props.inputClassName}
        id={this.id}
        onChange={this.getValue}
        name={props.name}
        value={this.value}
        tabIndex={props.tabIndex}
        disabled={props.disabled}>
        {props.hasEmpty && (
          <option value="" disabled={false}>
            {props.emptyLabel}
          </option>
        )}
        {props.values.map((entry: SelectValuesEntryType, index) => {
          return (
            <OptionComponent index={index} values={props.values} entry={entry} key={entry.value || `index-${index}`} />
          )
        })}
      </select>
    )
  }
}

class SelectOnly extends Select {
  render() {
    return this.formField()
  }
}

export default Select
export { SelectOnly }
